var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4424 0.737705L19.6223 0L23.1617 15.9458L23.4101 16.1728L23.6585 17.3644L23.8448 17.7049L24.5278 20.8827L22.2303 20.145L21.8577 18.0454L22.044 17.7049L21.7335 16.5132L21.8577 16.1728L18.4424 0.737705Z",
    fill: "#5DA3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5097 10.4414L48 10.8953L43.1565 24.855V25.2522L42.8461 26.1602V26.6141L41.0453 31.7781L39.7413 28.7705L40.7969 25.8197L41.1074 25.5359L41.4179 24.5712L41.6662 24.3443L46.5097 10.4414Z",
    fill: "#5DA3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5446 4.1425L32.9728 3.74527L32.7245 19.918L32.9107 20.2018V21.3934L33.0349 21.6772L32.9728 24.5712L30.9858 23.6633V21.6772L31.11 21.3934V20.2018L31.2963 19.918L31.5446 4.1425Z",
    fill: "#5DA3E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8085 18.2724L40.0517 27.4653L40.6727 28.884L24.0931 41.5952L0.186287 28.0895L19.8085 18.2724Z",
    fill: "url(#paint0_linear_1154_7082)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0931 41.5952L40.6727 28.884L44.1501 36.488L27.7568 45L24.0931 41.5952Z",
    fill: "#3872AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.186287 28.0895L24.0931 41.5952L27.7568 45L0 29.6217L0.186287 28.0895Z",
    fill: "#0057AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4618 36.715L17.2626 37.7364L16.7038 38.6444L15.0893 37.7364L15.4618 36.715Z",
    fill: "#5DA3E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1154_7082",
    x1: 22.3804,
    y1: 0.9854,
    x2: 47.4289,
    y2: 20.8044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6698E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936501,
    stopColor: "#55A1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0057FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/router.3663cb2d9b51ce91f9dd1f931d683929.svg";
export { ForwardRef as ReactComponent };